import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api, { formatApiError } from "../lib/api";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { ShieldAlert, X } from "lucide-react";
import { toast } from "sonner";

export function IncentivePermissionList() {
  const [users, setUsers] = useState([]);
  const load = () => api.get("/users").then((r) => setUsers((r.data || []).filter((u) => u.role !== "admin" && u.role !== "manager" && u.permissions?.incentives?.manage === true))).catch(() => {});
  useEffect(() => { load(); }, []);
  const revoke = async (u) => {
    if (!window.confirm(`${u.name} se Incentives access hatayein?`)) return;
    try {
      await api.put(`/users/${u.id}`, { permissions: { ...(u.permissions || {}), incentives: { ...(u.permissions?.incentives || {}), manage: false } } });
      toast.success("Access removed"); setUsers((x) => x.filter((y) => y.id !== u.id));
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <Card className="p-4 border-border shadow-none" data-testid="incentive-permission-list">
      <div className="font-heading font-semibold text-sm flex items-center gap-2 mb-1"><ShieldAlert className="h-4 w-4 text-amber-600" /> Employees with full Incentives access</div>
      <p className="text-xs text-muted-foreground mb-2">Baaki sab employees ko sirf "My Payslip" dikhta hai.</p>
      {users.length === 0 ? <div className="text-xs text-muted-foreground" data-testid="incentive-perm-empty">Kisi employee ko access nahi diya gaya.</div> : (
        <div className="flex flex-wrap gap-2">
          {users.map((u) => (
            <span key={u.id} className="inline-flex items-center gap-1.5 rounded-full border border-border pl-3 pr-1 py-0.5 text-sm" data-testid={`inc-perm-${u.id}`}>
              <Link to={`/employees/${u.id}`} className="hover:underline">{u.name}</Link>
              <span className="text-xs text-muted-foreground">{u.employee_code}</span>
              <Button size="icon" variant="ghost" className="h-6 w-6 text-red-500" onClick={() => revoke(u)} data-testid={`inc-perm-revoke-${u.id}`}><X className="h-3.5 w-3.5" /></Button>
            </span>
          ))}
        </div>
      )}
    </Card>
  );
}

export function IncentivesGuard({ children }) {
  const { user } = useAuth();
  const ok = user && (user.role === "admin" || user.role === "manager" || user.permissions?.incentives?.manage === true);
  return ok ? children : <Navigate to="/my-incentives" replace />;
}
